
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import Admin from './Admin/Admin';
import Login from './Admin/Login';
import BlogList from './Public/BlogList';
import PublicBlogPage from './Public/PublicBlogPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

  return (
    <>
  
        <HashRouter>
          <Routes>
            {/* Admin Login Route */}
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            {/* Admin Routes */}
              <Route
              path="/admin/*"
              element={isLoggedIn ? <Admin onLogout={handleLogout} /> : <Navigate to="/login" />}
            />
          </Routes>
        </HashRouter>

        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/blogs/:slug" element={<PublicBlogPage />} />
            <Route path="/blogs" element={<BlogList />} />

            {/* Catch-all Route - Redirect to public blogs */}
            <Route path="*" element={<Navigate to="/blogs" />} />
          </Routes>
        </BrowserRouter>

    </>
  );
}

export default App;

